module.exports = __webpack_public_path__ + "img/PZ.2fbe8ce5.png";